import Hero from './components/Hero';
import Features from './components/Features';
import CategorySection from './components/CategorySection';
import LatestArticles from './components/LatestArticles';
import CommunityHighlights from './components/CommunityHighlights';
import FAQ from './components/FAQ';
import { Link } from 'react-router-dom';

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '男同网 - 男同社群交友与资讯平台',
            description: '男同网是专为男同群体打造的综合性平台，提供交友、社群互动、生活资讯、权益支持等服务。',
            url: 'https://mylifeguide.github.io/',
            inLanguage: 'zh-CN',
            isPartOf: {
              '@type': 'WebSite',
              name: '男同网',
              url: 'https://mylifeguide.github.io/',
            },
          }),
        }}
      />

      <article>
        <Hero />

        <Features />

        <CategorySection />

        <LatestArticles />

        <CommunityHighlights />

        <section className="py-16 md:py-24 bg-primary-500">
          <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
            <h2 className="text-3xl md:text-4xl font-bold font-heading text-white mb-4">
              准备好加入我们了吗？
            </h2>
            <p className="text-white/80 text-base md:text-lg max-w-xl mx-auto mb-8 leading-relaxed">
              无论你是想交友、获取资讯还是寻求支持，男同网都欢迎你的到来。一起创造一个更温暖、更包容的社群。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/categories"
                className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-white text-primary-600 text-base font-semibold hover:bg-white/90 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                浏览内容
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
              <Link
                to="/about"
                className="w-full sm:w-auto px-8 py-3.5 rounded-lg border-2 border-white/30 text-white text-base font-medium hover:bg-white/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                联系我们
              </Link>
            </div>
          </div>
        </section>

        <FAQ />
      </article>
    </>
  );
}